import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { supabase } from "../lib/supabase";

function ChangePassword() {
  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    newPassword: "",
    confirmPassword: "",
  });

  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    setFormData((prev) => ({
      ...prev,
      [e.target.name]: e.target.value,
    }));
  };

  const handleUpdatePassword = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      if (!formData.newPassword.trim() || formData.newPassword.length < 6) {
        throw new Error("Password must be at least 6 characters.");
      }

      if (formData.newPassword !== formData.confirmPassword) {
        throw new Error("Passwords do not match.");
      }

      const { error } = await supabase.auth.updateUser({
        password: formData.newPassword,
      });

      if (error) throw error;

      alert("Password updated successfully.");
      navigate("/settings");
    } catch (error) {
      console.error("Change password error:", error);
      alert(error.message || "Failed to update password.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={page}>
      <div style={card}>
        <h1 style={{ marginTop: 0 }}>Change Password</h1>
        <p style={muted}>
          Update your password for phone/password or email/password login.
        </p>

        <form onSubmit={handleUpdatePassword}>
          <label style={label}>New Password</label>
          <input
            name="newPassword"
            type="password"
            value={formData.newPassword}
            onChange={handleChange}
            placeholder="Enter new password"
            style={input}
            required
          />

          <label style={label}>Confirm New Password</label>
          <input
            name="confirmPassword"
            type="password"
            value={formData.confirmPassword}
            onChange={handleChange}
            placeholder="Confirm new password"
            style={input}
            required
          />

          <button type="submit" disabled={loading} style={button}>
            {loading ? "Updating..." : "Update Password"}
          </button>
        </form>
      </div>
    </div>
  );
}

const page = {
  background: "radial-gradient(circle at top, #101010 0%, #000 55%)",
  minHeight: "100vh",
  padding: "40px 20px",
  color: "#fff",
  fontFamily: "Arial, sans-serif",
};

const card = {
  maxWidth: "560px",
  margin: "0 auto",
  background: "#111",
  padding: "24px",
  borderRadius: "18px",
  border: "1px solid #2a2a2a",
};

const muted = {
  color: "#d1d1d1",
  lineHeight: "1.7",
};

const label = {
  display: "block",
  marginBottom: "8px",
  marginTop: "12px",
  color: "#fff",
};

const input = {
  width: "100%",
  padding: "12px 14px",
  marginBottom: "12px",
  borderRadius: "10px",
  border: "1px solid #2a2a2a",
  background: "#0b0b0b",
  color: "#fff",
  boxSizing: "border-box",
};

const button = {
  width: "100%",
  padding: "12px 16px",
  borderRadius: "10px",
  border: "none",
  background: "#fff",
  color: "#000",
  fontWeight: "bold",
  cursor: "pointer",
  marginTop: "10px",
};

export default ChangePassword;
